var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendPageLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66675C6.77533 1.66675 4.16699 4.27508 4.16699 7.50008C4.16699 11.8751 10.0003 18.3334 10.0003 18.3334C10.0003 18.3334 15.8337 11.8751 15.8337 7.50008C15.8337 4.27508 13.2253 1.66675 10.0003 1.66675ZM5.83366 7.50008C5.83366 5.20008 7.70033 3.33341 10.0003 3.33341C12.3003 3.33341 14.167 5.20008 14.167 7.50008C14.167 9.90008 11.767 13.4917 10.0003 15.7334C8.26699 13.5084 5.83366 9.87508 5.83366 7.50008Z",
    fill: "#706F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 9.58341C11.1509 9.58341 12.0837 8.65067 12.0837 7.50008C12.0837 6.34949 11.1509 5.41675 10.0003 5.41675C8.84973 5.41675 7.91699 6.34949 7.91699 7.50008C7.91699 8.65067 8.84973 9.58341 10.0003 9.58341Z",
    fill: "#706F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPageLocation);
export default __webpack_public_path__ + "static/media/send-page-location.165beaf7.svg";
export { ForwardRef as ReactComponent };